import map from 'lodash/map'
import React, { memo, VFC } from 'react'
import styled from 'styled-components'

import { AccordionSidePane } from '@Components/CMS/AccordionSidePane'
import { ProductDimensions } from '@Components/Product/Dimensions'
import { DescriptionHeader, DescriptionSizeInfo, DescriptionTextWrapper } from '@Components/Product/Display/styledElements'
import { ProductMaterials } from '@Components/Product/Materials'
import { Product } from '@Generated/graphql'
import { up } from '@Globals/Style/breakpoints'
import { useTranslation } from '@Globals/Translations'

interface ProductDescriptionProps {
  product?: Product
  selectedVariantID?: string
}

const ProductIDWrapper = styled.aside(({ theme }) => `
  color: ${theme.colors.grey};
  font-size: .75rem;
  margin-top: ${theme.padding.desktop};
`)

const StyledAccordionSidePane = styled(AccordionSidePane)(({ theme }) => `
  border-top-width: 5px;
  border-top-color: ${theme.colors.greyLightest};

  ${up('mobileStyleThreshold')} {
    border-top-width: 1px;
    border-top-color: ${theme.colors.greyLighter};
    margin-top: ${theme.padding.tablet};
  }
`)

export const ProductDescription: VFC<ProductDescriptionProps> = memo(({ product, selectedVariantID }) => {
  const { t } = useTranslation()

  if (!product || !product.description) {
    return null
  }

  const processedDescriptionText = map(
    product.description.trim().split('\n'),
    (line, index) => {
      const trimmedData = line.trim()
      return trimmedData.length
        ? <p key={`${index}${line}`}>{trimmedData}</p>
        : null
    },
  )

  return (
    <StyledAccordionSidePane header={t('products:DESCRIPTION')}>
      <DescriptionHeader>{t('products:DESCRIPTION')}</DescriptionHeader>
      <DescriptionTextWrapper>
        {processedDescriptionText}

        <DescriptionSizeInfo>
          <ProductMaterials includeHeader product={product} selectedVariantID={selectedVariantID} />
          <ProductDimensions includeHeader product={product} selectedVariantID={selectedVariantID} />
        </DescriptionSizeInfo>

        <ProductIDWrapper>
          ID:
          {' '}
          {product.id}
        </ProductIDWrapper>
      </DescriptionTextWrapper>
    </StyledAccordionSidePane>
  )
})
